/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _module = __webpack_require__(1);
	
	var $window = $(window);
	var breakPoint = 767;
	
	var resizeFlag = false;
	var windowWidth = $window.width();
	var windowHeight = $window.height();
	
	//ページ内リンクのアニメーション
	
	(0, _module.anchorScroll)();
	
	//ページTOP
	
	(0, _module.pageTop)();
	
	//SPヘッダーの開閉
	
	(0, _module.spHeaderToggle)();
	
	//Headerスクロール時
	
	(0, _module.scrolledHeader)();
	
	// preload
	
	(0, _module.preload)();
	
	// resizing
	
	(0, _module.resizing)();
	
	$(function () {
	    // if(navigator.userAgent.match(/(iPhone|iPad|iPod|Android)/)){
	    //   $('.view-Attention').css({display:'block'});
	    // }
	
	    var isReverse = false; //正面が逆かどうかのフラグを用意しておく
	
	    if (navigator.userAgent.indexOf('Android') > 0) {
	        //Androidなら正面設定を確認
	        var orientation = screen.orientation || screen.mozOrientation || screen.msOrientation;
	        if (orientation.type === "portrait-secondary" || orientation.type === "landscape-primary") {
	            isReverse = true;
	        } else {
	            $('.view-Attention').css({ display: 'block' });
	        }
	    }
	
	    $(window).on("lord orientationchange", function () {
	        if (isReverse) {
	            orientCheckReverse(); //正面が逆の場合
	        } else {
	            orientCheck(); //正面が通常の場合
	        }
	    });
	
	    $('.view-Attention .btn').click(function () {
	        $('.view-Attention').fadeOut(200);
	    });
	});
	
	//正面設定が通常の場合の縦横判定処理
	function orientCheck() {
	    var orientation = window.orientation;
	    if (orientation === 0) {} else {
	        $('.view-Attention').css({ display: 'none' });
	    }
	};
	
	//正面設定が逆の場合の縦横判定処理
	function orientCheckReverse() {
	    var orientation = window.orientation;
	    if (orientation === 0) {} else {
	        $('.view-Attention').css({ display: 'none' });
	    }
	};

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var $window = $(window);
	var breakPoint = 767;
	
	var resizeFlag = false;
	var windowWidth = $window.width();
	var windowHeight = $window.height();
	//const bodyLimitHeight = (windowHeight - 185) * 0.88;
	
	var url = location.href;
	
	//ローディング
	var loading = function loading() {
	  var $target = $('#sw-Loading');
	  window.addEventListener('load', function () {
	    setTimeout(function () {
	      $target.fadeOut(600);
	    }, 1000);
	  });
	};
	
	//ページ内リンクのアニメーション
	var anchorScroll = function anchorScroll() {
	  var $anchor = $('a[href^=#]');
	  $anchor.click(function () {
	    var speed = 1000;
	    var href = $(this).attr('href');
	    var target = $(href == '#' || href == '' ? 'html' : href);
	    var position = target.offset().top;
	    $('html, body').animate({
	      scrollTop: position
	    }, speed, 'swing');
	    return false;
	  });
	};
	
	//ページTOP
	var pageTop = function pageTop() {
	  var topBtn = $('.sw-BackToTop');
	  topBtn.css({ visibility: 'hidden', opacity: 0 });
	  $(window).scroll(function () {
	    if ($(this).scrollTop() > 100) {
	      topBtn.css({ visibility: 'visible', opacity: 1 });
	    } else {
	      topBtn.css({ visibility: 'hidden', opacity: 0 });
	    }
	  });
	  topBtn.click(function () {
	    $('body,html').animate({
	      scrollTop: 0
	    }, 1000);
	    return false;
	  });
	};
	
	//SPヘッダーの開閉
	var spHeaderToggle = function spHeaderToggle() {
	  //config
	  var $header = $('#st-Header');
	  //toggle
	  var $headerTrigger = $('#st-Header_Hamburger');
	  $headerTrigger.on('click', function () {
	    $header.toggleClass('opened');
	    return false;
	  });
	};
	
	// Headerスクロール時
	var scrolledHeader = function scrolledHeader() {
	  var $header = $('.st-Header');
	  $(window).scroll(function () {
	    if ($(this).scrollTop() > 0) {
	      $header.addClass('scrolled');
	    } else {
	      $header.removeClass('scrolled');
	    }
	  });
	};
	
	// preload
	var preload = function preload() {
	  $(window).on('load', function () {
	    $("body").removeClass("preload");
	  });
	};
	
	// resizing
	var resizing = function resizing() {
	  var timer = 0;
	  $(window).on('resize', function () {
	    $("body").addClass("resizing");
	    if (timer > 0) {
	      clearTimeout(timer);
	    }
	    timer = setTimeout(function () {
	      $("body").removeClass("resizing");
	      // console.log('window resized');
	    }, 100);
	  });
	};
	
	//export
	exports.loading = loading;
	exports.anchorScroll = anchorScroll;
	exports.pageTop = pageTop;
	exports.spHeaderToggle = spHeaderToggle;
	exports.scrolledHeader = scrolledHeader;
	exports.preload = preload;
	exports.resizing = resizing;

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// mosaicart/app.bundle.js